import classNames from 'classnames'
import plur from 'plur'
import * as React from 'react'

import styles from './AgentsSelectionSummary.css'

type Props = {
  className: string | undefined
  targetAgentPoolName: string
  selectedCloudImagesCount: number
  selectedCloudAgentsCount: number
  selectedSelfHostedAgentsCount: number
  selectedUnauthorizedAgentsCount: number
  availableAgentSlotsCount: number
}

function plurAgent(count: number): string {
  return plur('agent', count)
}

export function AgentsSelectionSummary({
  targetAgentPoolName,
  selectedCloudImagesCount,
  selectedCloudAgentsCount,
  selectedSelfHostedAgentsCount,
  selectedUnauthorizedAgentsCount,
  className,
  availableAgentSlotsCount,
}: Props) {
  const selectedItemsCount = selectedCloudImagesCount + selectedSelfHostedAgentsCount
  const selectedAgentsCount = selectedCloudAgentsCount + selectedSelfHostedAgentsCount

  return selectedItemsCount > 0 ? (
    <div className={classNames(className, styles.summary)}>
      {availableAgentSlotsCount < Infinity ? (
        <div>
          {selectedCloudAgentsCount > 0 && selectedSelfHostedAgentsCount > 0
            ? `${selectedAgentsCount} ${plurAgent(
                selectedAgentsCount,
              )} selected: ${selectedCloudAgentsCount} cloud ${plurAgent(
                selectedCloudAgentsCount,
              )} and ${selectedSelfHostedAgentsCount} stand-alone ${plurAgent(
                selectedSelfHostedAgentsCount,
              )}.`
            : selectedCloudAgentsCount > 0
            ? `${selectedCloudAgentsCount} cloud ${plurAgent(selectedCloudAgentsCount)} selected.`
            : selectedSelfHostedAgentsCount > 0
            ? `${selectedSelfHostedAgentsCount} stand-alone ${plurAgent(
                selectedSelfHostedAgentsCount,
              )} selected.`
            : null}
          {selectedAgentsCount > 0
            ? `${
                selectedAgentsCount > availableAgentSlotsCount ? ' Only' : ''
              } ${availableAgentSlotsCount} ${plur('slot', availableAgentSlotsCount)} available.`
            : null}
        </div>
      ) : null}
      {selectedAgentsCount <= availableAgentSlotsCount ? (
        selectedUnauthorizedAgentsCount === selectedAgentsCount &&
        selectedCloudImagesCount === 0 ? (
          <div>
            {`${selectedUnauthorizedAgentsCount} ${plurAgent(
              selectedUnauthorizedAgentsCount,
            )} will be reassigned to `}
            <em>{targetAgentPoolName}</em>
            {' and automatically authorized.'}
          </div>
        ) : (
          <div>
            {selectedCloudImagesCount > 0
              ? `${selectedCloudImagesCount} ${plur('cloud image', selectedCloudImagesCount)}${
                  selectedSelfHostedAgentsCount > 0 ? ' and ' : ''
                }`
              : ''}
            {selectedSelfHostedAgentsCount > 0
              ? `${selectedSelfHostedAgentsCount} stand-alone ${plurAgent(
                  selectedSelfHostedAgentsCount,
                )}`
              : ''}
            {' will be reassigned to '}
            <em>{targetAgentPoolName}</em>
            {'.'}
            {selectedUnauthorizedAgentsCount > 0
              ? ` ${selectedUnauthorizedAgentsCount} ${plurAgent(
                  selectedUnauthorizedAgentsCount,
                )} will be automatically authorized.`
              : ''}
          </div>
        )
      ) : (
        <div>{'Please adjust the selection.'}</div>
      )}
    </div>
  ) : null
}
